import http from "./AxiosInstance";

class BonClientService {
  
// Famille

getBonClient() {
  return http.get("/bonclients");
}

getBonClientPending() {
  return http.get(`/bonclients/pending`);
}

/* 
getBonClientPending(nom) {
  return http.get(`/bonclients/pending/${encodeURIComponent(nom)}`);
} */


getBonClientVendu() {
  return http.get("/bonclients/vendu");
}

getBonByClient(idClient) {
  return http.get(`/bonclients/client/${idClient}`);
}

getBonClientByStatut(id,statut) {
  return http.get(`/bonclients/statut/${id}/${encodeURIComponent(statut)}`,id,statut);
}

vendreBons(data) {
  return http.put("/bonclients/vendre",data);
}

annulerBon(id) {
  return http.delete(`/bonclients/annuler/${id}`);
}


getTypeBonClient(idType) {
  return http.get(`/bonclients/${idType}`);
}

createBonClient(data){
  return http.post("/bonclients/save",data)
}

updateBonClient(data,id) {
  return http.put(`/bonclients/update/${id}`, data);
}

deleteBonClient(id) {
  return http.delete(`/bonclients/delete/${id}`);
}

deleteBon(id) {
  return http.delete(`/bonclients/deletebon/${id}`);
}


savePayement(data){
  return http.post("/payement/save",data)
}

getTypePayement() {
  return http.get(`/payement/typepayement`);
}

payerTout(data) {
  return http.put(`/payement/payertout`,data);
}

getStatistiques(statut){
  return http.get(`/bonclients/etat/${statut}`);
}


searchBonClientByPeriod(date1, date2, idClient = null, statut = null) {
  let url = `/bonclients/search/${date1}/${date2}`;
  const params = [];
  
  if (idClient) {
    url += `/${idClient}`;
    if (statut) {
      url += `/${encodeURIComponent(statut)}`;
    }
  } else if (statut) {
    url += `/null/${encodeURIComponent(statut)}`;
  }
  
  return http.get(url);
}

// Recherche de bons par période seulement
searchBonClientByDateOnly(date1, date2) {
  return http.get(`/bonclients/search/${date1}/${date2}`);
}

// Recherche de bons par période et statut
searchBonClientByPeriodAndStatut(date1, date2, statut) {
  return http.get(`/bonclients/search/${date1}/${date2}/null/${encodeURIComponent(statut)}`);
}


geSynthese() {
  return http.get('/bonclients/synthese');
}

getSyntheseComplet() {
  return http.get('/bonclients/synthese/complet');
}

getBonsPayes(periode)  {
  return http.get(`/bonclients/payes/${periode}`);
}

getBonsImpayes(periode)  {
  return http.get(`/bonclients/impayes/${periode}`);
}

getRepartitionParType(periode)  {
  return http.get(`/bonclients/repartition/${periode}`);
}

  
}
const bonClientService = new BonClientService();
export default bonClientService;